var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000080180876211976022690000002923550442475172516_);}\r\n\t.st2{fill:url(#SVGID_00000183223736506802437260000009892843553292445579_);}\r\n\t.st3{fill:url(#SVGID_00000030459336545707972230000005456521800281122465_);}\r\n\t.st4{fill:url(#SVGID_00000137113138992947981110000006912810931471632306_);}\r\n\t.st5{fill:url(#SVGID_00000098178856354613315590000010070747587386293902_);}\r\n\t.st6{fill:url(#SVGID_00000012436947934764697370000005935877901249994113_);}\r\n\t.st7{fill:url(#SVGID_00000177449586145173561590000017333464581490142653_);}\r\n\t.st8{fill:url(#SVGID_00000008852904057972048450000007944047452483346837_);}\r\n\t.st9{fill:url(#SVGID_00000021832036863074786880000017373978459542258611_);}\r\n\t.st10{fill:url(#SVGID_00000073717811680809999880000008180325387015438527_);}\r\n\t.st11{fill:url(#SVGID_00000098930104335349093750000014020286920916094091_);}\r\n\t.st12{fill:url(#SVGID_00000098932769263986135240000008750498363841313435_);}\r\n\t.st13{fill:url(#SVGID_00000148644389391130464710000010640806541414995884_);}\r\n\t.st14{fill:url(#SVGID_00000142136655675419230140000006719406423024045757_);}\r\n\t.st15{fill:url(#SVGID_00000143580568218802393940000003216385150089268631_);}\r\n\t.st16{fill:url(#SVGID_00000025441020876753557140000010549930797077311632_);}\r\n\t.st17{fill:url(#SVGID_00000173860244635537776780000005457349463826654631_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 852.5938,
    cy: 861.2037,
    r: 241.8798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAF43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F06724"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1073.82,623.84c-7.88,0-15.39-1.5-22.89-4.32c-15.57-6.19-31.33-11.07-47.28-15.01v203.96 c0,9.95-5.44,19.14-13.89,24.21l-358.76,206.96c-1.5,0.94-3,1.5-4.5,2.06v76.18c14.82-1.13,29.08-5.63,42.03-13.13l358.76-207.15 c31.71-18.2,51.41-52.35,51.41-89.13V623.47C1077.01,623.84,1075.51,623.84,1073.82,623.84z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000068677502405493192920000018220591255004242083_",
    cx: 315.9504,
    cy: 908.0193,
    r: 241.9297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068677502405493192920000018220591255004242083_)"
    },
    d: "M244.46,832.68 c-8.63-5.07-13.89-14.26-13.89-24.21V604.33c-16.7,2.25-32.09,5.44-46.53,9.76c-6.19,1.88-12.38,2.81-18.58,2.81 c-3.38,0-6.75-0.19-9.94-0.94v192.52c0,36.78,19.7,70.93,51.41,89.13l358.76,207.15c12.95,7.51,27.21,12.01,42.03,13.13v-76.18 c-1.5-0.56-3-1.31-4.5-2.06L244.46,832.68z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000032632720992679285330000017065098709345002672_",
    cx: 448.8917,
    cy: 783.0527,
    r: 231.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032632720992679285330000017065098709345002672_)"
    },
    d: "M368.68,749l239.05,137.91v78.62 c-11.26-1.13-21.95-4.5-31.71-10.13L331.15,813.92c-25.33-14.45-41.09-41.84-41.09-71.12V600.57h0.56 c25.33,0,50.66,1.69,74.49,3.75V742.8C365.11,745.43,366.42,747.68,368.68,749z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000150798985013393072970000003890622689852271017_",
    cx: 876.0173,
    cy: 754.6565,
    r: 172.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150798985013393072970000003890622689852271017_)"
    },
    d: "M944.16,594.95V742.8 c0,29.27-15.76,56.67-41.09,71.12L658.2,955.4c-9.76,5.63-20.45,9.01-31.71,10.13v-78.62L865.54,749 c2.25-1.31,3.57-3.57,3.57-6.19V596.07c14.07-1.5,28.9-2.25,44.47-2.25C923.9,593.82,934.22,594.2,944.16,594.95z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000142885308123166703820000010296762899726127028_",
    cx: 899.3399,
    cy: 397.2187,
    r: 188.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAF43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F06724"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142885308123166703820000010296762899726127028_)"
    },
    d: "M1065.5,577.61 c22.44,8.86,36.13-31.15,26.81-53.4c-0.15-0.36-0.3-0.72-0.45-1.08c-8.23-19.52-29.06-20.85-50.23-21.54 c-170.54-5.53-211.05-42.61-122.88-212.85c9.74-18.81,19.26-37.39,6.46-54.27c-0.24-0.32-0.48-0.63-0.72-0.95 c-14.71-19.33-54.45-26.84-59.98-3.18c-35.63,152.17-187.93,268.75-156.96,322.39C735.37,600.94,878.13,503.67,1065.5,577.61z  M921.72,427.57c19.29,33.42,116.47,39.58,143.94,0.17c42.34-60.84,2.91-129.14-70.95-122.89 C946.84,308.94,904.49,397.73,921.72,427.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000160902586828300730530000011447282334507959965_",
    cx: 334.3897,
    cy: 390.2681,
    r: 188.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160902586828300730530000011447282334507959965_)"
    },
    d: "M369.26,223.34 c-3.55-23.86-45.05-15.72-59.65,3.48c-0.24,0.31-0.47,0.62-0.71,0.93c-12.79,16.89-3.53,35.59,6.46,54.27 c80.48,150.46,68.62,204.08-122.89,212.85c-21.16,0.97-42.01,2.01-50.23,21.54c-0.15,0.37-0.31,0.73-0.46,1.1 c-9.39,22.4,3.98,60.57,27.24,53.54c149.6-45.23,326.71,28.38,357.68-25.26C554.54,497.57,398.91,422.58,369.26,223.34z  M311.22,422.87c19.3-33.42-23.95-120.66-71.82-124.75c-73.86-6.25-113.29,62.05-70.95,122.9 C195.92,460.43,293.99,452.71,311.22,422.87z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000017513843002220067100000015235311501365265810_",
    cx: 619.2534,
    cy: 285.5749,
    r: 209.0717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017513843002220067100000015235311501365265810_)"
    },
    d: "M819.65,199.49 c18.89-15.01-8.91-46.87-32.84-49.92c-0.38-0.05-0.77-0.1-1.16-0.15c-21.02-2.64-32.59,14.74-43.77,32.73 c-90.06,144.93-142.43,161.47-245.77,0c-11.42-17.84-22.75-35.37-43.77-32.73c-0.39,0.05-0.79,0.1-1.18,0.15 c-24.09,3.07-50.46,33.74-32.75,50.36c113.97,106.94,138.78,297.13,200.72,297.13C674.79,497.05,661.93,324.78,819.65,199.49z  M617.83,248.98c38.59,0,92.51-81.07,72.12-124.57c-31.52-67.09-110.39-67.09-141.9,0 C527.64,167.91,583.37,248.98,617.83,248.98z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000020370883945291162420000006546977545077426367_",
    cx: 338.6388,
    cy: 902.7358,
    r: 844.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020370883945291162420000006546977545077426367_)"
    },
    d: "M318.75,888.53l-79.98-46.14 c-12-7.04-19.46-20.03-19.46-33.92V617.44c-11.42,1.96-21.98,4.42-32.02,7.42c-6.78,2.05-13.67,3.15-20.51,3.28v180.33 c0,32.76,17.54,63.16,45.78,79.38l113.56,65.57C322.27,932.18,319.73,910.54,318.75,888.53z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085972538471740829410000014563661278070300071_",
    cx: 788.2337,
    cy: 594.7581,
    r: 1157.9863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085972538471740829410000014563661278070300071_)"
    },
    d: "M323.68,794.35 c5.76-38.16,16.06-74.97,30.18-109.97v-69.7c-15.42-1.23-33.55-2.4-52.53-2.75V742.8C301.32,762.59,309.66,781.17,323.68,794.35 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000037653961072703693220000014279668793059081870_",
    cx: 858.4902,
    cy: 472.1131,
    r: 776.8659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAF43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B2A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037653961072703693220000014279668793059081870_)"
    },
    d: "M1049.75,428.19 c2.59-2.13,4.93-4.39,6.66-6.88c16.67-23.93,19.94-51.01,8.75-72.43c-10.84-20.76-33.7-33.15-61.14-33.15 c-2.73,0-5.52,0.11-8.36,0.35c-17.85,1.52-38.75,20.45-53.23,48.21c-3.44,6.59-6.14,12.97-8.19,18.98 C974.83,393.41,1013.58,408.6,1049.75,428.19z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000157295051805164942660000014436364761226176423_",
    cx: 858.4897,
    cy: 472.1121,
    r: 776.8636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAF43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B2A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157295051805164942660000014436364761226176423_)"
    },
    d: "M816.38,368.64 c18.39,0,36.56,1.13,54.48,3.15c7.54-24.71,19.99-53.68,37.88-88.21c9.94-19.22,15.63-31.55,6.78-43.24 c-5.85-7.7-18.29-13.5-28.92-13.5c-9.71,0-10.78,4.58-11.14,6.08c-11.57,49.4-34.96,94.96-60.45,135.76 C815.47,368.67,815.92,368.64,816.38,368.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000162337328320682643050000017250616093991902898_",
    cx: 788.2359,
    cy: 594.7585,
    r: 1157.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162337328320682643050000017250616093991902898_)"
    },
    d: "M239.87,436.69 C239.88,436.69,239.88,436.69,239.87,436.69c31.53,0,56.07-9.88,61.6-19.44c6.72-11.64,2.68-36.46-9.81-60.4 c-14.26-27.32-35.15-45.97-53.21-47.51c-2.84-0.24-5.63-0.35-8.36-0.35c-27.43,0-50.29,12.39-61.14,33.15 c-11.19,21.42-7.92,48.5,8.74,72.45C187.19,428.23,211.02,436.69,239.87,436.69z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097469841166655097800000016949557752168477883_",
    cx: 788.2347,
    cy: 594.7574,
    r: 1157.9896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097469841166655097800000016949557752168477883_)"
    },
    d: "M431.4,553.57 c18.95-23.14,39.96-44.53,62.65-64.01c-4.4-5.57-9.1-11.38-14.2-17.63C438.47,421.19,375.92,344.51,358.13,225 c-0.21-1.39-0.76-5.09-9.68-5.09c-10.72,0-24.12,6.16-30.58,14.64c-7.58,10-3.84,21.11,7.42,42.16 c39.97,74.73,61.93,132.7,39.16,172.78c-19.95,35.11-71.23,52.04-171.47,56.64c-23.68,1.06-35.39,2.86-40.82,15.74 c-3.93,9.38-2.31,24.26,3.62,33.17c1.69,2.56,4.42,5.61,7.71,5.61c0.7,0,1.47-0.13,2.26-0.37c35.6-10.76,75.76-16,122.8-16 c37.69,0,74.42,3.32,106.84,6.25C407.86,551.65,419.95,552.74,431.4,553.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000166657057420564202460000003614334120829605273_",
    cx: 788.2338,
    cy: 594.7549,
    r: 1157.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166657057420564202460000003614334120829605273_)"
    },
    d: "M617.83,237.73 c13.42,0,32.9-15.92,47.38-38.7c16.54-26,22.25-53.41,14.55-69.83c-12.9-27.45-35.61-43.85-60.76-43.85s-47.86,16.4-60.75,43.85 c-7.6,16.22-1.67,43.76,15.14,70.2C589.2,224.28,608.09,237.73,617.83,237.73z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097499378384990245170000009856886641221534889_",
    cx: 788.2344,
    cy: 594.7564,
    r: 1157.9747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#28A8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D61AE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097499378384990245170000009856886641221534889_)"
    },
    d: "M549.34,385.7 c8.03,17.35,15.7,33.9,23.2,48.4c30.91-17.71,63.76-32.3,98.18-43.1c23.68-59.21,61.05-136.07,141.93-200.33 c1.44-1.15,2.65-2.49,1.59-6.32c-2.86-10.24-17.43-22.17-29.98-23.77c-0.94-0.13-1.86-0.18-2.76-0.18 c-11.93,0-19.98,11.47-30.06,27.69c-44.87,72.21-84.23,120.3-130.48,120.3c-0.01,0-0.01,0-0.02,0 c-40.24,0-80.41-35.93-134.31-120.17c-11.08-17.3-18.64-27.82-30.18-27.82c-0.88,0-1.79,0.06-3.87,0.35 c-11.34,1.43-24.71,12.13-28.05,22.43c-1.54,4.77-0.06,6.98,1.59,8.54C485.27,247.22,520.8,324,549.34,385.7z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000029749038396194572510000016113811654581339027_",
    cx: 613.5114,
    cy: 745.005,
    r: 156.9669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029749038396194572510000016113811654581339027_)"
    },
    d: "M806.04,639.22 c-54.45,79.92-148.02,83-192.3,170.23c-44.28-87.23-137.85-90.31-192.3-170.23c4.81,17.22,3.61,29.99-0.84,38.69 c-3.7,7.23-2.74,15.97,2.11,22.49c37.52,50.46,126.62,70.51,174.03,127v6.59c0,9.28,7.52,16.81,16.8,16.81 c0.07,0,0.13-0.01,0.2-0.01c0.07,0,0.13,0.01,0.2,0.01c9.28,0,16.8-7.52,16.8-16.81v-6.59c47.08-56.1,135.29-76.26,173.25-125.97 c5.41-7.08,6.04-16.58,2.32-24.67C802.33,668.09,801.44,655.7,806.04,639.22z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000153669647892620699810000003383059570957011598_",
    cx: 514.1033,
    cy: 681.6906,
    r: 96.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153669647892620699810000003383059570957011598_)"
    },
    d: "M607.77,780.02 c0,0-9.81-31.31-89.07-77.54c-79.26-46.22-96.22-88.11-96.22-88.11s-4.59-23.26,0-31.01c17.98,31.72,53.87,66.76,105.38,98.33 C599.76,725.75,607.77,780.02,607.77,780.02z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000129163464663789753600000005660369613236991364_",
    cx: 707.4048,
    cy: 685.215,
    r: 96.0245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CC540"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#069F49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129163464663789753600000005660369613236991364_)"
    },
    d: "M613.74,783.54 c0,0,9.81-31.31,89.07-77.54c79.26-46.22,96.22-88.11,96.22-88.11s4.59-23.26,0-31.01c-17.98,31.72-53.87,66.76-105.38,98.33 C621.75,729.27,613.74,783.54,613.74,783.54z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogos);
export default __webpack_public_path__ + "static/media/Logos.707fabb6d2c40524f136103dba4b50b9.svg";
export { ForwardRef as ReactComponent };